import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../components/minimal-layout';
export const _frontmatter = {
  "title": "Newsletter"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Subscribe = makeShortcode("Subscribe");
const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Blocks newsletter`}</h1>
    <Subscribe skipTitle={true} mdxType="Subscribe" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      